import React from 'react';

import RefreshIcon from '@atlaskit/icon/glyph/refresh';

import { locationReload } from 'src/lib/history';

function onClick() {
  locationReload();
}

const ReloadButton = () => (
  <div className="icon" onClick={onClick} data-cy="sidebar-reload-button"><RefreshIcon/></div>
);

export default ReloadButton;
